import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import type { IUserTransaction } from '@/interfaces';
import { TypeBadge } from './components/TypeBadge';
import { AmountDisplay } from './components/AmountDisplay';
import { getTitleEnumValue } from '@/functions';
import { DataTableTransactionDetails } from './DataTableBodyCellDetails';
import { CoinAddedByEnum, ProductsEnum } from '@/enums';

type TProps = {
	transaction: IUserTransaction;
};

export const DataTableMobileCard = ({ transaction }: TProps) => {
	const productLabel = getTitleEnumValue('ProductsEnum', transaction.product);
	const comment = transaction.options?.comment;
	const hasDetails =
		transaction.product === ProductsEnum.PAID_COINS ||
		transaction.product === ProductsEnum.SEND_DM ||
		transaction.options?.coinsAddedBy === CoinAddedByEnum.MANUALLY;

	return (
		<div className="w-full p-4 border rounded-lg bg-card text-card-foreground shadow-xs hover:bg-muted/50 transition-colors">
			<div className="flex items-start justify-between">
				<div className="space-y-2 flex-1 cursor-default text-left overflow-hidden">
					<div className="flex flex-col items-start gap-1">
						<TypeBadge type={transaction.type} />
						<span className="text-xs text-muted-foreground font-medium">{productLabel}</span>
					</div>
					<div className="text-sm font-medium">
						{hasDetails ? (
							<DataTableTransactionDetails transaction={transaction} showEmpty={false} />
						) : (
							<div className="line-clamp-2">{comment || productLabel}</div>
						)}
					</div>
				</div>
				<div className="flex items-start gap-3">
					<div className="text-right">
						<AmountDisplay amount={transaction.amount} type={transaction.type} />
						<div className="text-[11px] text-muted-foreground mt-1">
							{format(new Date(transaction.createdAt), 'dd MMM yyyy', { locale: fr })}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DataTableMobileCard;
